import { render, staticRenderFns } from "./greenhouse-jobs.datatable.vue?vue&type=template&id=6e219d10&scoped=true&"
import script from "./greenhouse-jobs.datatable.vue?vue&type=script&lang=js&"
export * from "./greenhouse-jobs.datatable.vue?vue&type=script&lang=js&"
import style0 from "./greenhouse-jobs.datatable.vue?vue&type=style&index=0&id=6e219d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e219d10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
